export default __webpack_public_path__ + "static/media/tooltipIcon.c7b2c3d8.svg";